<template>
  <div>
    <div class="grid gap-y-2 gap-x-8 sm:grid-cols-1 md:grid-cols-2">
      <div class="panel">
        <div class="panel-body">
          <Summary :data="summary" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <reasons-discard :series="discarded_series" :labels="discarded_labels" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <harvest-monthly :data="harvests_monthly" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <ok-discard-monthly :data="totals_monthly" />
        </div>
      </div>
      <div class="panel" v-if="Object.keys(crop_sizes).length > 1">
        <div class="panel-body">
          <crop-sizes :data="crop_sizes" />
        </div>
      </div>
      <div class="panel" v-if="Object.keys(crop_size_packages).length > 1">
        <div class="panel-body">
          <crop-size-packages :data="crop_size_packages" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Summary from "@/components/views/producer/reporting/process/charts/Summary.vue";
import ReasonsDiscard from "@/components/views/producer/reporting/process/charts/ReasonsDiscard.vue";
import HarvestMonthly from "@/components/views/producer/reporting/process/charts/HarvestMonthly.vue";
import OkDiscardMonthly from "@/components/views/producer/reporting/process/charts/OkDiscardMonthly.vue";
import CropSizes from "@/components/views/producer/reporting/process/charts/CropSizes.vue";
import CropSizePackages from "@/components/views/producer/reporting/process/charts/CropSizePackages.vue";
export default {
  name: "PRODReportingProcessShowReportsSummary",
  components: {
    Summary,
    ReasonsDiscard,
    HarvestMonthly,
    OkDiscardMonthly,
    CropSizes,
    CropSizePackages
  },
  props: {
    producer_id: { required: true },
    agro_exporter_process_id: { required: true },
    summary: { required: true },
    harvests_monthly: { required: true },
    totals_monthly: { required: true },
    crop_sizes: { required: true },
    crop_size_packages: { required: true },
    discarded_motives: { required: true }
  },
  computed: {
    series() {
      return [
        {
          name: "",
          data: this.data_weekly
        }
      ];
    },
    discarded_series() {
      return this.discarded_motives.map(dm => dm.value);
    },
    discarded_labels() {
      return this.discarded_motives.map(dm => dm.name);
    }
  }
};
</script>
